import { IMemberBotPageParams } from "shared/pages/MembersBotPage";

import { IMembersChatState } from "./MembersChatModule";

export default class MembersChatSelectors {
  public static applicationId = (state: IMembersChatState) =>
    state.applicationId;

  public static application = (state: IMembersChatState) =>
    state.application.prop;

  public static applicationIsFetching = (state: IMembersChatState) =>
    state.application.isFetching;
  public static applicationFetchError = (state: IMembersChatState) =>
    Boolean(state.application.error);

  public static coworkName = (state: IMembersChatState) => state.coworkName;

  public static selectedPlaceCoworkLocation = (state: IMembersChatState) =>
    state.selectedPlaceLocation;

  public static isAssignedApplication = (state: IMembersChatState) =>
    Boolean(MembersChatSelectors.coworkName(state));

  public static isAssignedApplicationByPageProps = (
    props: IMemberBotPageParams
  ) => Boolean(props.cowork);

  public static memberBotType = (state: IMembersChatState) => state.botType;

  public static landbotProps = (state: IMembersChatState) => state.botProps;
}



// WEBPACK FOOTER //
// ./src/state/modules/membersChat/MembersChatSelectors.ts